export enum DialogEnum {
  Login = "login",
  Register = "register",
}
